
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1.171","y":".7","width":"17.6","height":"17.6","rx":"3.3","stroke":"#7B01B5","stroke-width":"1.4"}}),_c('path',{attrs:{"d":"M6.343 5.921h.989c.043 0 .086.005.127.013l.121.04c.04.016.077.037.111.062l.095.085a.61.61 0 01.075.102l.053.116a.61.61 0 01.028.25.63.63 0 01-.132.315l-.08.084a.63.63 0 01-.31.144l-.114.01h-.963a.38.38 0 00-.38.379v3.958a.38.38 0 00.38.38h.989c.043 0 .086.004.127.013l.121.039a.62.62 0 01.111.062l.095.085a.612.612 0 01.075.103l.053.116a.61.61 0 01.028.25.63.63 0 01-.521.543l-.115.009h-.963a1.6 1.6 0 01-1.014-.363l-.117-.106a1.6 1.6 0 01-.469-1.131V7.521c0-.371.13-.73.362-1.014l.107-.117a1.6 1.6 0 011.13-.469zM12.61 5.921h.99a1.6 1.6 0 01.463.07l.149.052c.145.06.28.142.402.242l.116.105c.112.112.206.239.28.377l.067.142a1.6 1.6 0 01.122.612v3.958a1.6 1.6 0 01-.07.464l-.052.148c-.06.146-.142.281-.241.403l-.106.116a1.6 1.6 0 01-.377.28l-.141.066a1.6 1.6 0 01-.612.123h-.963a.63.63 0 01-.613-.439L12 12.527a.61.61 0 01.001-.126l.027-.124a.613.613 0 01.053-.116l.075-.103a.616.616 0 01.095-.085l.111-.062c.04-.018.08-.03.121-.04l.127-.012h.99a.38.38 0 00.38-.38V7.521a.38.38 0 00-.38-.38h-.963a.63.63 0 01-.33-.086l-.094-.067a.631.631 0 01-.189-.285L12 6.589a.61.61 0 01.001-.126l.027-.124a.612.612 0 01.053-.116l.075-.102a.612.612 0 01.095-.085l.111-.063c.04-.017.08-.03.121-.039l.127-.013zM9.972 4.272a.61.61 0 01.61.61v9.236a.61.61 0 01-.95.508l-.092-.077a.61.61 0 01-.179-.431V4.882c0-.121.037-.24.103-.339l.076-.092a.611.611 0 01.432-.179z","fill":"#7B01B5","stroke":"#7B01B5","stroke-width":".1"}})])
          )
        }
      }
    